import client from "./client";

export const dashboardApi = {
  getLicences: () => client.get("/api/dashboard/licences"),
  deactivateMachine: (licenceKey, fingerprint) =>
    client.post(`/api/dashboard/licences/${licenceKey}/deactivate-machine?fingerprint=${fingerprint}`),
  getDownload: () => client.get("/api/dashboard/download"),
  getInvoices: () => client.get("/api/dashboard/invoices"),
};
